module.exports = __webpack_public_path__ + "howstrt-b79c09d6.webp";